import React, { useContext } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { AppContext, AppContextProvider } from '../../utils/AppContext';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next'


const SectionPromote = () => {
    const appContext = useContext(AppContext);
    const { t } = useTranslation();

    const desktopStyles = {
        contentContainerStyle: {
            display: "flex",
            flexDirection: "row",
            padding: "20px 80px",
            marginBottom: "50px",
            backgroundColor: appContext.colors.primaryBlue,
            fontFamily: appContext.fontFamily.poppins
        },
        subtitleStyle: {
            fontSize: "22px",
            fontWeight: "400",
            margin: "0",
            alignSelf: "center",
            color: appContext.colors.primaryWhite
        },

        downloadButtonStyle: {
            textDecoration: "none",
            fontFamily: appContext.fontFamily.inter,
            fontSize: "20px",
            fontWeight: "600",
            marginLeft: "auto",
            padding: "10px 20px",
            borderRadius: "50px",
            color: appContext.colors.primaryBlue,
            backgroundColor: appContext.colors.primaryWhite,
        },
    }

    const mobileStyles = {
        contentContainerStyle: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            padding: "20px",
            marginBottom: "50px",
            backgroundColor: appContext.colors.primaryBlue
        },

        subtitleStyle: {
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "400",
            color: appContext.colors.primaryWhite
        },

        downloadButtonStyle: {
            textDecoration: "none",
            fontFamily: appContext.fontFamily.inter,
            fontSize: "14px",
            marginTop: "10px",
            fontWeight: "600",
            padding: "10px 20px",
            borderRadius: "50px",
            color: appContext.colors.primaryBlue,
            backgroundColor: appContext.colors.primaryWhite,
        },
    }

    const styles = appContext.mobileMode ? mobileStyles : desktopStyles

    const onDownload = () => {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        ReactGA.initialize("G-3CZYHKHHW6");
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            ReactGA.event({
                category: "download",
                action: "app_store"
            });
            window.open("https://woilo.com/appstore/ios.php?source=202", '_blank').focus();
            return;
        }
        ReactGA.event({
            category: "download",
            action: "play_store"
        });
        window.open("https://woilo.com/appstore/android.php?source=202", '_blank').focus();
    }

    return (
        <>
            <div style={styles.contentContainerStyle}>
                <h3 style={styles.subtitleStyle}>
                    <b> {t("landingPage.sectionPromote.title")}</b>
                </h3>
                <Link style={styles.downloadButtonStyle} onClick={onDownload}>{t("landingPage.button.download3")}</Link>
            </div>
        </>
    )
}

export default SectionPromote;